import { render, staticRenderFns } from "./prical.vue?vue&type=template&id=b5f0cc7a&scoped=true"
import script from "./prical.vue?vue&type=script&lang=js"
export * from "./prical.vue?vue&type=script&lang=js"
import style0 from "./prical.vue?vue&type=style&index=0&id=b5f0cc7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f0cc7a",
  null
  
)

export default component.exports